import { Outlet } from 'react-router';
import { useRef } from 'react';
import Navbar from '../components/Navbar/Navbar';
import useScrollToTopOnMount from '../hooks/useScrollToTopOnMount';
import MainFooter from '../components/ModernFooter/MainFooter';
import ScrollToTop from '../hooks/ScrollToTop';
import CheckAuthRedirect from '../hooks/CheckAuthRedirect';

export default function BaseLayout() {
  useScrollToTopOnMount();
  ScrollToTop();
  const sectionRef = useRef<HTMLDivElement>(null);

  return (
    <main className="min-h-screen w-full">
      <CheckAuthRedirect />
      <Navbar sectionRef={sectionRef} />
      <Outlet context={{ sectionRef }} />
      <MainFooter />
    </main>
  );
}
